"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _icon = _interopRequireDefault(require("../../icon/icon.presenter"));
var _iconContainer = require("./iconContainer.helper");
var _mergeInputField = require("../mergeInputField.shapes");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var IconContainer = function IconContainer(_ref) {
  var sourceType = _ref.sourceType,
    hasSuggestion = _ref.hasSuggestion,
    locale = _ref.locale;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('iconContainer', {
      suggestion: hasSuggestion
    }),
    title: (0, _iconContainer.translateSourceTypeToTooltip)({
      sourceType: sourceType,
      locale: locale
    })
  }, _react.default.createElement(_icon.default, {
    name: (0, _iconContainer.translateSourceTypeToIconName)(sourceType)
  }));
};
IconContainer.propTypes = {
  sourceType: _propTypes.string.isRequired,
  locale: _mergeInputField.localeShape.isRequired,
  hasSuggestion: _propTypes.bool
};
var _default = IconContainer;
exports.default = _default;